import { render, staticRenderFns } from "./ContentFields.vue?vue&type=template&id=5ed4ec78&scoped=true&"
import script from "./ContentFields.vue?vue&type=script&lang=js&"
export * from "./ContentFields.vue?vue&type=script&lang=js&"
import style0 from "./ContentFields.vue?vue&type=style&index=0&id=5ed4ec78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed4ec78",
  null
  
)

export default component.exports